var map = {
	"./informagiovani/public/components/PrivacyPolicy/PrivacyPolicy.vue": [
		"b287",
		"chunk-2d20f005"
	],
	"./informagiovani/public/components/Registration/Registration.vue": [
		"524d",
		"chunk-08fb050d"
	],
	"./informagiovani/public/components/RegistrationWithSpidProxy/RegistrationWithSpidProxy.vue": [
		"8a0d",
		"chunk-0486a1fd"
	],
	"./informagiovani/public/components/Result/Result.vue": [
		"663d",
		"chunk-2d0cfe47"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "995e";
module.exports = webpackAsyncContext;